import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useDispatch, useSelector } from 'react-redux';

import { otpAuthAPI } from '../api/authAPI';
import { IVerifyOtp } from '../types/Auth';
import { startSession } from '../libs/session';
import { toOtpAuthError } from '../libs/otpAuthError';
import { setAuth } from '../../../store/slices/userSlice';
import { userInfo } from '../../../store/selectors/user';
import { custonSooner } from '../../../components/CustopmSooner';
import { captureApiError } from '../../../lib/sentry-utils';
import { toApiPhone } from '../../../utils/formatPhone';

/**
 * Проверка кода.
 *
 * У знакомого номера это и есть вход: в ответе сразу токен и клиент. У
 * незнакомого — только `is_registered: false`, и код остаётся действительным
 * для `register`: этот эндпоинт строку кода не гасит и не помечает.
 */
export const useVerifyOtp = () => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const user = useSelector(userInfo);

  const { mutateAsync, isPending } = useMutation({
    mutationFn: async ({ phone, otp }: IVerifyOtp) => {
      const res = await otpAuthAPI.verifyOtp({ phone: toApiPhone(phone), otp });
      const data = res.data.data;

      if (data.token) startSession(data.token, queryClient);

      return data;
    },
    onSuccess: data => {
      if (!data.token) return;

      dispatch(setAuth({ ...user, isAuth: true }));
    },
    onError: error => {
      captureApiError(error, '/client/otp-auth/verify-otp', 'POST');
      custonSooner.error(toOtpAuthError(error).message);
    },
  });

  return {
    verifyOtp: mutateAsync,
    isPending,
  };
};
